import { Trans } from '@lingui/macro'
import { Button, Typography } from '@mui/material'
import { useHistory } from 'react-router'
import ContactUsButton from '../common-components/ContactUsButton/ContactUsButton'
import './NotFound.css'
import { MAIN_PATH } from 'app/RootConstants'

const NotFound: React.FC = () => {
  const history = useHistory()

  return (
    <div className='not-found-wrapper'>
      <div className='not-found-container'>
        <div className='not-found-title-404'>
          <span className='not-found-digit-1'>4</span>
          <span className='not-found-digit-2'>0</span>
          <span className='not-found-digit-3'>4</span>
        </div>
        <div className='not-found-text-container'>
          <Typography
            sx={{
              color: (theme) => theme.palette.primary.main
            }}
            className='mb-32 not-found-title'
          >
            <Trans>
              NOT_FOUND_TITLE
            </Trans>
          </Typography>
          <Typography className='mb-48 not-found-description'>
            <Trans>
              NOT_FOUND_DESCRIPTION
            </Trans>
          </Typography>
        </div>
        <div className='not-found-row'>
          <Button
            variant='contained'
            color='primary'
            onClick={() => history.push(MAIN_PATH)}
          >
            <Trans>
              NOT_FOUND_GO_TO_HOMEPAGE
            </Trans>
          </Button>
          <ContactUsButton variant='outlined' />
        </div>
      </div>
    </div>
  )
}

export default NotFound
